import NavMenu from "../../common/NavMenu.js";

// props: {
//   animationDelay: number
//   closed: boolean
//   direction: string (horizontal or vertical)
//   menuButton: string (class or id selector)
//   menuContainer: string (class or id selector)
//   menuLink: string (class selector)
//   onOpen: function (callback when the menu opens)
//   parent: node element
// }

export default () => {
  document.querySelectorAll(".js-accordion-categories").forEach((el, i) => {
    const accordionCategories = new NavMenu({
      animationDelay: 250,
      closed: true,
      direction: "vertical",
      menuButton: ".js-accordion-categories-toggle",
      menuContainer: ".js-accordion-categories-links",
      menuLink: "a",
      parent: el,
    });
  });
};
